// Multilingual UI translations
export const translations = {
  fr: {
    appName: "tadekir",
    tagline: "Un rappel à portée du cœur",
    home: "Accueil",
    prayer: "Prière",
    quran: "Coran",
    names: "99 Noms",
    dhikr: "Dhikr",
    hijri: "Calendrier",
    prophets: "Prophètes",
    qibla: "Qibla",
    duas: "Dou'as",
    arabic: "Alphabet",
    tafsir: "Tafsir",
    quiz: "Quiz",
    game: "Jeu",
    values: "Valeurs",
    sacred_nights: "Nuits sacrées",
    sacred_nights_sub: "Laylat al-Qadr & nuits bénies",
    zakat: "Zakat",
    zakat_sub: "Calculateur d'aumône légale",
    hifz: "Mémorisation",
    mosques: "Mosquées",
    mosques_sub: "Lieux saints & mosquées proches",
    in_days: "jours",
    worship_program: "Programme d'adoration",
    more: "Plus",
    next_prayer: "Prochaine prière",
    verse_of_day: "Verset du jour",
    hadith_of_day: "Hadith du jour",
    today: "Aujourd'hui",
    in: "dans",
    h: "h",
    min: "min",
    sec: "s",
    locate_me: "Localiser",
    permission_denied: "Permission de localisation refusée. Saisissez vos coordonnées.",
    source: "Source",
    transliteration: "Translittération",
    translation: "Traduction",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher",
    reset: "Réinitialiser",
    count: "Compteur",
    target: "Objectif",
    start_quiz: "Commencer le quiz",
    categories: "Catégories",
    pillars: "Piliers de l'Islam",
    moral_values: "Valeurs morales",
    score: "Score",
    correct: "Bonne réponse",
    wrong: "Mauvaise réponse",
    hint: "Indice",
    streak: "Série",
    settings: "Paramètres",
    language: "Langue",
    welcome: "Bienvenue",
    intro: "Une application complète pour découvrir, apprendre et pratiquer l'Islam.",
    explore: "Explorer",
    start: "Commencer",
    play_again: "Rejouer",
    bismillah: "Au nom d'Allah",
    isolated: "Isolée",
    initial: "Initiale",
    medial: "Médiane",
    final: "Finale",
    explanation: "Explication",
    context: "Contexte",
    miracle: "Miracle",
    story: "Récit",
    wake: "Réveil",
    meal: "Repas",
    travel: "Voyage",
    trials: "Épreuves",
    final_score: "Score final",
    great_job: "Excellent travail, qu'Allah t'accorde le savoir.",
    keep_going: "Continue, chaque pas vers la science est béni.",
    qibla_calibrate: "Bougez votre appareil en forme de 8 pour calibrer la boussole.",
    direction_to_mecca: "Direction vers La Mecque",
    not_supported: "Capteur d'orientation non disponible sur cet appareil.",
    location_error: "Impossible de récupérer la position."
  },
  en: {
    appName: "tadekir",
    tagline: "A reminder within your heart's reach",
    home: "Home", prayer: "Prayer", quran: "Quran", names: "99 Names",
    dhikr: "Dhikr", hijri: "Calendar", prophets: "Prophets", qibla: "Qibla",
    duas: "Du'as", arabic: "Alphabet", tafsir: "Tafsir", quiz: "Quiz",
    game: "Game", values: "Values",
    sacred_nights: "Sacred nights",
    sacred_nights_sub: "Laylat al-Qadr & blessed nights",
    zakat: "Zakat",
    zakat_sub: "Zakat calculator",
    hifz: "Memorization",
    mosques: "Mosques",
    mosques_sub: "Holy places & nearby mosques",
    in_days: "days",
    worship_program: "Worship program",
    more: "More",
    next_prayer: "Next prayer", verse_of_day: "Verse of the day",
    hadith_of_day: "Hadith of the day", today: "Today", in: "in",
    h: "h", min: "min", sec: "s",
    locate_me: "Locate me",
    permission_denied: "Location permission denied. Enter coordinates manually.",
    source: "Source", transliteration: "Transliteration", translation: "Translation",
    next: "Next", previous: "Previous", search: "Search", reset: "Reset",
    count: "Counter", target: "Target",
    start_quiz: "Start quiz", categories: "Categories",
    pillars: "Pillars of Islam", moral_values: "Moral values",
    score: "Score", correct: "Correct", wrong: "Wrong",
    hint: "Hint", streak: "Streak", settings: "Settings", language: "Language",
    welcome: "Welcome",
    intro: "A complete app to discover, learn and practice Islam.",
    explore: "Explore", start: "Start", play_again: "Play again",
    bismillah: "In the name of Allah",
    isolated: "Isolated", initial: "Initial", medial: "Medial", final: "Final",
    explanation: "Explanation", context: "Context", miracle: "Miracle", story: "Story",
    wake: "Waking", meal: "Meal", travel: "Travel", trials: "Trials",
    final_score: "Final score",
    great_job: "Excellent work, may Allah grant you knowledge.",
    keep_going: "Keep going, every step is blessed.",
    qibla_calibrate: "Wave your device in a figure 8 to calibrate.",
    direction_to_mecca: "Direction to Mecca",
    not_supported: "Orientation sensor not available on this device.",
    location_error: "Unable to retrieve position."
  },
  ar: {
    appName: "تذكير",
    tagline: "نور الإسلام والذكر بين يديك",
    home: "الرئيسية", prayer: "الصلاة", quran: "القرآن", names: "أسماء الله",
    dhikr: "الذكر", hijri: "التقويم", prophets: "الأنبياء", qibla: "القبلة",
    duas: "الأدعية", arabic: "الحروف", tafsir: "التفسير", quiz: "اختبار",
    game: "لعبة", values: "القيم", more: "المزيد",
    next_prayer: "الصلاة القادمة", verse_of_day: "آية اليوم",
    hadith_of_day: "حديث اليوم", today: "اليوم", in: "في",
    h: "س", min: "د", sec: "ث",
    locate_me: "حدد موقعي",
    permission_denied: "تم رفض إذن الموقع.",
    source: "المصدر", transliteration: "النطق", translation: "الترجمة",
    next: "التالي", previous: "السابق", search: "بحث", reset: "إعادة",
    count: "العدّاد", target: "الهدف",
    start_quiz: "ابدأ الاختبار", categories: "الأقسام",
    pillars: "أركان الإسلام", moral_values: "القيم الأخلاقية",
    score: "النتيجة", correct: "صحيح", wrong: "خطأ",
    hint: "تلميح", streak: "متتالية", settings: "الإعدادات", language: "اللغة",
    welcome: "مرحبا",
    intro: "تطبيق متكامل لاكتشاف وتعلم وممارسة الإسلام.",
    explore: "استكشف", start: "ابدأ", play_again: "العب مرة أخرى",
    bismillah: "بسم الله",
    isolated: "منفصلة", initial: "أول", medial: "وسط", final: "آخر",
    explanation: "شرح", context: "سياق", miracle: "معجزة", story: "قصة",
    wake: "الاستيقاظ", meal: "الطعام", travel: "السفر", trials: "الابتلاء",
    final_score: "النتيجة النهائية",
    great_job: "أحسنت، بارك الله فيك.",
    keep_going: "استمر، كل خطوة مباركة.",
    qibla_calibrate: "حرك جهازك على شكل 8 للمعايرة.",
    direction_to_mecca: "اتجاه القبلة",
    not_supported: "مستشعر الاتجاه غير متاح.",
    location_error: "تعذر تحديد الموقع."
  },
  es: {
    appName: "tadekir",
    tagline: "Un recuerdo al alcance del corazón",
    home: "Inicio", prayer: "Oración", quran: "Corán", names: "99 Nombres",
    dhikr: "Dhikr", hijri: "Calendario", prophets: "Profetas", qibla: "Qibla",
    duas: "Súplicas", arabic: "Alfabeto", tafsir: "Tafsir", quiz: "Cuestionario",
    game: "Juego", values: "Valores",
    sacred_nights: "Noches sagradas",
    sacred_nights_sub: "Laylat al-Qadr y noches bendecidas",
    zakat: "Zakat",
    zakat_sub: "Calculadora de Zakat",
    hifz: "Memorización",
    mosques: "Mezquitas",
    mosques_sub: "Lugares santos y mezquitas cercanas",
    in_days: "días",
    worship_program: "Programa de adoración",
    more: "Más",
    next_prayer: "Próxima oración", verse_of_day: "Versículo del día",
    hadith_of_day: "Hadiz del día", today: "Hoy", in: "en",
    h: "h", min: "min", sec: "s",
    locate_me: "Localizar",
    permission_denied: "Permiso de ubicación denegado.",
    source: "Fuente", transliteration: "Transliteración", translation: "Traducción",
    next: "Siguiente", previous: "Anterior", search: "Buscar", reset: "Reiniciar",
    count: "Contador", target: "Meta",
    start_quiz: "Comenzar cuestionario", categories: "Categorías",
    pillars: "Pilares del Islam", moral_values: "Valores morales",
    score: "Puntuación", correct: "Correcto", wrong: "Incorrecto",
    hint: "Pista", streak: "Racha", settings: "Ajustes", language: "Idioma",
    welcome: "Bienvenido",
    intro: "Una aplicación completa para descubrir y practicar el Islam.",
    explore: "Explorar", start: "Comenzar", play_again: "Jugar de nuevo",
    bismillah: "En el nombre de Allah",
    isolated: "Aislada", initial: "Inicial", medial: "Medial", final: "Final",
    explanation: "Explicación", context: "Contexto", miracle: "Milagro", story: "Relato",
    wake: "Despertar", meal: "Comida", travel: "Viaje", trials: "Pruebas",
    final_score: "Puntuación final",
    great_job: "¡Excelente! Que Allah te conceda el saber.",
    keep_going: "Sigue así, cada paso es una bendición.",
    qibla_calibrate: "Mueve tu dispositivo en forma de 8 para calibrar.",
    direction_to_mecca: "Dirección a La Meca",
    not_supported: "Sensor de orientación no disponible.",
    location_error: "No se pudo obtener la ubicación."
  },
  tr: {
    appName: "tadekir",
    tagline: "Kalbinizin yanında bir hatırlatma",
    home: "Ana sayfa", prayer: "Namaz", quran: "Kur'an", names: "99 İsim",
    dhikr: "Zikir", hijri: "Takvim", prophets: "Peygamberler", qibla: "Kıble",
    duas: "Dualar", arabic: "Alfabe", tafsir: "Tefsir", quiz: "Sınav",
    game: "Oyun", values: "Değerler",
    sacred_nights: "Mübarek geceler",
    sacred_nights_sub: "Kadir gecesi ve mübarek geceler",
    zakat: "Zekât",
    zakat_sub: "Zekât hesaplayıcı",
    hifz: "Ezberleme",
    mosques: "Camiler",
    mosques_sub: "Kutsal yerler ve yakın camiler",
    in_days: "gün",
    worship_program: "İbadet programı",
    more: "Daha fazla",
    next_prayer: "Sıradaki namaz", verse_of_day: "Günün ayeti",
    hadith_of_day: "Günün hadisi", today: "Bugün", in: "içinde",
    h: "s", min: "d", sec: "sn",
    locate_me: "Konum",
    permission_denied: "Konum izni reddedildi.",
    source: "Kaynak", transliteration: "Telaffuz", translation: "Çeviri",
    next: "İleri", previous: "Geri", search: "Ara", reset: "Sıfırla",
    count: "Sayaç", target: "Hedef",
    start_quiz: "Sınavı başlat", categories: "Kategoriler",
    pillars: "İslam'ın şartları", moral_values: "Ahlaki değerler",
    score: "Puan", correct: "Doğru", wrong: "Yanlış",
    hint: "İpucu", streak: "Seri", settings: "Ayarlar", language: "Dil",
    welcome: "Hoş geldiniz",
    intro: "İslam'ı keşfetmek, öğrenmek ve yaşamak için tam bir uygulama.",
    explore: "Keşfet", start: "Başla", play_again: "Tekrar oyna",
    bismillah: "Allah'ın adıyla",
    isolated: "Tek başına", initial: "Baş", medial: "Orta", final: "Son",
    explanation: "Açıklama", context: "Bağlam", miracle: "Mucize", story: "Kıssa",
    wake: "Uyanış", meal: "Yemek", travel: "Yolculuk", trials: "İmtihan",
    final_score: "Nihai skor",
    great_job: "Aferin, Allah ilim versin.",
    keep_going: "Devam et, her adım mübarektir.",
    qibla_calibrate: "Cihazı 8 şeklinde hareket ettirerek kalibre edin.",
    direction_to_mecca: "Kıble yönü",
    not_supported: "Yönelim sensörü mevcut değil.",
    location_error: "Konum alınamadı."
  }
};

export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" }
];
